import { invoiceSlice } from './slice';

export const {
  setInvoiceState,
  setAllProjects,
  setInvoiceBasicDetails,
  setAllProjectWork,
  setAllProjectExpenses,
  setProjectWork,
  setProjectExpense,
  setLineItems,
  createLineItem,
  deleteLineItem,
  updateLineItem,
  updateLineItemOrder,
  updateAllLineItemsTaxAndFinalAmount,
  resetAllData,
  setSelectedProjectsAndCurrency,
  setSourceMappingOrder,
  setBudgetOrderByProject,
  setFields,
  setSelectProjectsFilter,
} = invoiceSlice.actions;

export const invoiceReducer = invoiceSlice.reducer;
